import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PageSelector from '../../../components/PageSelector';
import LoadingPage from "../../../components/Loading";
import DropdownMenu from '../components/Dropdown'
import { utils, writeFile } from 'xlsx';
import SearchSvg from '../../../svgs/SearchSvg'
import * as XLSX from 'xlsx';
import { fetchRegistrationForms } from "../../../services/registrationForms";
import { fetchRegistrationFormTemplateById } from "../../../services/registrationFormTemplates";

function Page(props) {
    const { id: templateId } = useParams();

    const [isloading, setisloading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const limit = parseInt(searchParams.get('limit')) || 10
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const [template, settemplate] = useState({})
    const page = parseInt(searchParams.get('page')) || 1
    const filterEmail = searchParams.get('email')

    const handleSearchEmail = (e) => { setSearchParams({ page: 1, email: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        const filter = { templateId }

        if (filterEmail) filter['email'] = { "$regex": filterEmail, "$options": 'i' }
        const res = await fetchRegistrationForms(props.token.token, filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } })
        if (res.errno) return
        const templateResult = await fetchRegistrationFormTemplateById(templateId)
        if (templateResult?.result) settemplate(templateResult.result) 
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item, index) {
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }





    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]">

            <div className="w-full flex flex-row gap-[8px] flex-wrap items-center justify-between mb-[16px]">

                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchEmail} placeholder="電子郵件搜尋" className="bg-[transparent] w-[130px] border-none text-[12px]" />
                </div>


                <div className="flex flex-row flex-1 justify-end items-center" style={{ gap: 8 }}>



                </div>
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px]" style={{ overflowY: 'auto' }}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{ borderBottom: '2px solid #6E604C' }}>
                    <div className="w-[24px] h-[24px] flex flex-row items-center">
                        <input type="checkbox" checked={data?.every(p => p.isSelected)} onChange={(e) => {
                            let isAllSelected = data?.every(p => p.isSelected)
                            let d = [...data];
                            for (let i of data) {
                                i.isSelected = isAllSelected ? false : true
                            }
                            setData(d)
                        }} />
                    </div>
                    <div className="flex-[2]">電郵地址(Email)</div>
                    <div className="flex-[1]">報名時間</div>

                    {template?.questions?.map((q, qi) =>
                        q.isVisibleInData?<div key={qi} className="flex-[1]">{q.question}</div> : 
                        null)}
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item, index) =>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center w-full text-[12px] text-[black] font-[400] py-[8px]" style={{ borderBottom: '.5px solid #fff', backgroundColor: item.isSelected ? '#ccc' : 'transparent' }}>
                            <div className="w-[24px] h-[24px] flex flex-row items-center">
                                <input type="checkbox" checked={item.isSelected} onChange={(e) => {
                                    let d = [...data];
                                    for (let i of data) {
                                        if (i._id === item._id) i.isSelected = !i.isSelected
                                    }
                                    setData(d)
                                }} />
                            </div>
                            <div className="flex-[2]">{item?.email || ''}</div>
                            <div className="flex-[1]">{item?.createDate ? (new Date(item?.createDate)).toLocaleString() : ''}</div>
                            {template?.questions?.map((q, qi) =>
                                q.isVisibleInData?<div key={qi} className="flex-[1]">
                                    {item?.questions[qi]?.answer||''}
                                </div> : 
                                null)}
                        </div>
                    )}
                    {data?.length === 0 && <div className="w-full h-full flex flex-col items-center justify-center">
                        <div className="text-[16px] text-[#6E604C] font-[700]">沒有參與者</div>
                        <div className="text-[12px] text-[#6E604C] font-[400]">請稍後再試</div>
                    </div>}
                </div>
            </div>

            <div className="flex flex-row w-full">
                <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />
                <DropdownMenu options={[10, 25, 50, 100, 500, 1000]} value={'每頁顯示: ' + limit} style={{ fontSize: 10 }} select={
                    (item, index) => {
                        searchParams.delete('limit')
                        searchParams.set('limit', item)
                        setSearchParams(searchParams)
                    }
                } dropup={true} />
            </div>



            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)




const ReloadSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={17}
        fill="none"
        {...props}
    >
        <path
            fill="#7A7A7A"
            d="M14.445 7.931a7.07 7.07 0 0 0-1.071-2.545 7.16 7.16 0 0 0-1.922-1.922 7.077 7.077 0 0 0-4-1.214V.667L4.31 3.039l3.144 2.373v-1.58a5.505 5.505 0 0 1 3.113.943 5.539 5.539 0 0 1 .82 8.507 5.557 5.557 0 0 1-2.797 1.508 5.641 5.641 0 0 1-2.231 0 5.538 5.538 0 0 1-4.42-5.424H.354c.001 1.418.425 2.804 1.218 3.98a7.192 7.192 0 0 0 1.92 1.92 7.078 7.078 0 0 0 3.98 1.217 7.128 7.128 0 0 0 5.902-3.139 7.08 7.08 0 0 0 1.215-3.978c0-.482-.049-.963-.145-1.435Z"
        />
    </svg>
)